module.exports = __webpack_public_path__ + "img/edit-check.357eed32.svg";